import { Button, Tooltip } from "antd";
import { useScopeParams } from "@/hooks/useScopeParams";
import logo from "../../assets/icons/logo.png";

interface GuideButtonProps {
  pageName: string;
  isAskVivo?: boolean;
  collapsed?: boolean;
  testId?: string;
}

export default function GuideButton({
  pageName,
  isAskVivo = false,
  collapsed = false,
  testId = "guide-button",
}: GuideButtonProps) {
  const { buildUrl } = useScopeParams();

  const openGuide = (slug: string) => {
    // Remove leading slash if present for buildUrl
    const cleanSlug = slug.startsWith("/") ? slug.slice(1) : slug;
    window.open(buildUrl(cleanSlug), "_blank");
  };

  return (
    <>
      <Tooltip title="View Vivo quickstart guide for this page">
        <Button
          data-testid={testId}
          className={
            isAskVivo
              ? `askvivo-header-action shadow-none ${
                  !collapsed ? "px-[9px]" : "rounded-md px-[6px] h-[35px]"
                }`
              : "shadow-none rounded-md px-[6px] h-[35px]"
          }
          onClick={() => openGuide(pageName)}
        >
          <div className="flex items-center gap-2">
            <img src={logo} alt="logo" className="w-6 h-auto" />
            {!collapsed && (
              <span className={isAskVivo ? "button-text hide-on-small" : ""}>
                Wiki
              </span>
            )}
          </div>
        </Button>
      </Tooltip>
    </>
  );
}
